<template>
  <div>
    <v-card class="rounded_max mt-5" flat>
      <div class="pa-3">
        <v-card flat class="rounded-lg" color="#f6f6f6">
          <v-row no-gutters>
            <v-col cols="12" md="5">
              <div class="pa-2">
                <v-text-field
                  placeholder="Search Facilitator"
                  solo
                  v-model="find"
                  @keyup="fetchData"
                  hide-details
                  dense
                  prepend-inner-icon="mdi-magnify"
                  flat
                ></v-text-field>
              </div>
            </v-col>
            <v-col cols="12" md="3">
              <div class="pa-2">
                <v-select
                  dense
                  hide-details
                  :items="optStatus"
                  item-text="txt"
                  item-value="val"
                  v-model="status"
                  @change="fetchData()"
                  placeholder="Filter Status"
                  flat
                  solo
                ></v-select>
              </div>
            </v-col>
            <v-col cols="12" md="2">
              <div class="pa-2">
                <v-menu
                  v-model="menuLimit"
                  bottom
                  :nudge-bottom="55"
                  elevation="0"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      depressed
                      class="text-capitalize color_txt"
                      height="38px"
                      block
                      color="#fff"
                      v-bind="attrs"
                      v-on="on"
                      ><p class="default_txt">Show : {{ limit }}</p>
                      <v-icon>mdi-chevron-down</v-icon>
                    </v-btn>
                  </template>
                  <v-card class="popup_radius" outlined elevation="0">
                    <v-list>
                      <v-list-item link @click="changeLimit(10)">
                        <v-list-item-title>10</v-list-item-title>
                      </v-list-item>
                      <v-list-item link @click="changeLimit(50)">
                        <v-list-item-title>50</v-list-item-title>
                      </v-list-item>
                      <v-list-item link @click="changeLimit(100)">
                        <v-list-item-title>100</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-menu>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </div>
      <!--  ========================================================================= data table -->
      <div>
        <v-skeleton-loader
          type="table-tbody"
          v-if="loading"
        ></v-skeleton-loader>
        <div v-if="dataSet && !loading">
          <v-data-table
            :headers="headers"
            :items="dataSet"
            :page.sync="page"
            :items-per-page="limit"
            class="elevation-0 color_txt"
            hide-default-footer
            :single-select="false"
          >
            <template v-slot:[`item.member`]="{ item }">
              <div class="d-flex">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      small
                      depressed
                      color="blue"
                      dark
                      class="text-capitalize"
                      v-bind="attrs"
                      v-on="on"
                      :to="`/facilitator/inclass/schedule/${idCourse}/${item.user_id}`"
                    >
                      <v-icon dark small class="mr-1">
                        mdi-account-group
                      </v-icon>
                      Schedule Facilitator
                    </v-btn>
                  </template>
                  <span>Manage Schedule</span>
                </v-tooltip>
              </div>
            </template>
          </v-data-table>
        </div>
      </div>
      <div class="text-center pa-3" v-if="dataSet">
        <v-pagination
          v-model="page"
          color="#006341"
          @input="fetchData"
          :length="last_page"
        ></v-pagination>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "memberScholarFacilitator",
  props: ["color", "idCourse"],
  data() {
    return {
      loading: true,
      dataSet: null,
      page: 1,
      limit: 10,
      total: null,
      last_page: null,
      find: "",
      status: "",
      optStatus: [
        { txt: "Active", val: 1 },
        { txt: "No Active", val: 2 },
      ],
      headers: [
        {
          text: "ID",
          align: "start",
          value: "id",
        },
        {
          text: "Name",
          align: "start",
          value: "data_user.name",
        },
        {
          text: "Email",
          align: "start",
          value: "data_user.email",
        },
        {
          text: "Username",
          align: "start",
          value: "data_user.username",
        },
        { text: "Member", sortable: false, value: "member" },
      ],

      menuLimit: false,
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      let course = this.$route.params.idCourse;
      let filter = `filter[course_id]=${course}&filter[search]=${this.find}&filter[dataUser.permissions.id]=4&filter[status]=${this.status}`;
      this.loading = true;
      let data = {
        path: `course/teacher?${filter}&page[number]=${this.page}&page[size]=${this.limit}&include=dataUser`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.dataSet = data.data;
          this.total = data.total;
          this.last_page = data.last_page;
          this.loading = false;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    changeLimit(val) {
      this.limit = val;
      this.fetchData();
    },
  },
};
</script>

<style></style>
